var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Fletja út kennslutímabil")]),_c('change-term-type',{attrs:{"item":_vm.item},on:{"finishCopy":function($event){return _vm.closeSlidebar()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }